export default "__VITE_ASSET__6c1fb29d__"